import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class PackageServices {
    static constructor() { }

    static setAgency(agency) {
        this.agency = agency;
        return this;
    }

    static getPackages(status, include, filters, cursor) {
        let baseUrl = 'packages';

        if (typeof this.agency !== 'undefined') {
            baseUrl = `${baseUrl}/${this.agency.id}/agency`;
        }

        return HTTP.get(baseUrl, {
            params: {
                status: status,
                include: include,
                filters: filters,
                cursor,
                limit: 10
            }
        })
            .then((response) => {
                return {
                    data: response.data.packages,
                    meta: response.data.meta
                }
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static getPackage(packageId, includes) {
        return HTTP.get(`packages/${packageId}`, {
            params: {
                include: includes
            }
        })
            .then((response) => {
                return response.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static updatePackage(_package) {
        return HTTP.post(`packages/${_package.id}`, _package)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static updatePackageAgencyPermission(_package, agency) {
        return HTTP.get(`agencies/${agency.id}/packages/${_package.id}`)
            .then((response) => {
                return response.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static updatePackageClientPermission(_package, client) {
        return HTTP.get(`clients/${client.id}/packages/${_package.id}`)
            .then((response) => {
                return response.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }


    static createPackage(_package) {
        _package.status = 'published';
        return HTTP.post(`packages`, _package)
            .then((response) => {
                // Transformer needs to include address by default;
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

}

export default PackageServices;
